import Cookies from 'universal-cookie';

export function CookieService() {
    let cookies = new Cookies();
    let anon_cookie_check = cookies.get('galingu_anon_cookie');
    return(anon_cookie_check)
}
